"use strict";

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var antd_1 = require("antd");

var layout_1 = require("../layout");

exports.LayoutHeader = styled_components_1["default"](antd_1.Layout.Header)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.LayoutFooter = styled_components_1["default"](antd_1.Layout.Footer)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.Layout = styled_components_1["default"](antd_1.Layout)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    && {\n        background: ", ";\n    }\n"], ["\n    && {\n        background: ", ";\n    }\n"])), function (_a) {
  var theme = _a.theme,
      bgcolor = _a.bgcolor;
  return bgcolor ? theme.color[bgcolor] : 'none';
});

exports.Content = function (_a) {
  var children = _a.children,
      className = _a.className,
      basicProps = __rest(_a, ["children", "className"]);

  return React.createElement(layout_1.LayoutContext.Consumer, null, function (_a) {
    var layoutVariant = _a.layoutVariant;
    return React.createElement(ContentContainer, __assign({
      layout: layoutVariant,
      className: className
    }, basicProps), children);
  });
};

var ContentContainer = styled_components_1["default"](antd_1.Layout.Content)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-width: ", ";\n    width: 100%;\n    ", "\n    padding: ", ";\n\n    @media (max-width: ", ") {\n        padding: ", ";\n    }\n"], ["\n    max-width: ", ";\n    width: 100%;\n    ", "\n    padding: ", ";\n\n    @media (max-width: ", ") {\n        padding: ", ";\n    }\n"])), function (_a) {
  var theme = _a.theme,
      layout = _a.layout;
  return layout === 'hcenter' ? theme.breakpoints.xl : null;
}, function (_a) {
  var layout = _a.layout;
  return layout === 'hcenter' ? 'margin: 0 auto;' : '';
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.breakpoints.sm;
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing.sm;
});

exports.LeftSider = function (props) {
  return React.createElement(layout_1.LayoutContext.Consumer, null, function (_a) {
    var currentHeaderHeight = _a.currentHeaderHeight;
    return React.createElement(StyledLeftSider, __assign({
      trigger: null,
      breakpoint: "md"
    }, props), React.createElement(FixedContainer, {
      paddingTop: currentHeaderHeight,
      breakpoint: props.breakpoint || 'md',
      width: props.width,
      collapsedWidth: props.collapsedWidth
    }, props.children));
  });
};

var StyledLeftSider = styled_components_1["default"](antd_1.Layout.Sider)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background: ", ";\n    transition: none;\n"], ["\n    background: ", ";\n    transition: none;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.color.white;
});
var FixedContainer = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border-right: 1px solid ", ";\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: ", ";\n    padding-top: ", "px;\n    transition: padding-top 200ms ease-in-out;\n    overflow: auto;\n\n    @media screen and (max-width: ", ") {\n        width: ", ";\n    }\n"], ["\n    border-right: 1px solid ", ";\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: ", ";\n    padding-top: ", "px;\n    transition: padding-top 200ms ease-in-out;\n    overflow: auto;\n\n    @media screen and (max-width: ", ") {\n        width: ", ";\n    }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.border.main;
}, function (_a) {
  var width = _a.width;
  return width;
}, function (_a) {
  var paddingTop = _a.paddingTop;
  return paddingTop;
}, function (_a) {
  var theme = _a.theme,
      breakpoint = _a.breakpoint;
  return theme.breakpoints[breakpoint];
}, function (_a) {
  var collapsedWidth = _a.collapsedWidth;
  return collapsedWidth;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;